import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmInputPurchaseOrder, IUser} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';
import moment from 'moment/moment';

export function PurchaseOrderStatusHistoryCard(props: {
  purchaseOrder?: IFarmInputPurchaseOrder;
  isLoading?: boolean;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.purchaseOrder) return null;
  const {purchaseOrder} = props;
  const formatDate = (date: string): string => {
    return moment(parseInt(date)).format('YYYY-MM-DD');
  };
  const formatUserName = (user: IUser): string => {
    return `${user.name} ${user.surname}`;
  };
  return (
    <Card className="purchase-order-status-history-card" variant="outlined">
      <Box className="row">
        <Box className="date-container">
          <Typography className="bold" variant="body2">
            Date
          </Typography>
        </Box>
        <Box className="user-container">
          <Typography className="bold" variant="body2">
            User
          </Typography>
        </Box>
        <Box className="status-container">
          <Typography className="bold" variant="body2">
            Status
          </Typography>
        </Box>
      </Box>
      {purchaseOrder?.statusUpdates.map((update) => (
        <div key={update.id}>
          <Divider />
          <Box className="row">
            <Box className="date-container">
              <Typography variant="body2" color="textSecondary">
                {formatDate(update.date)}
              </Typography>
            </Box>
            <Box className="user-container">
              <Typography variant="body2" color="textSecondary">
                {formatUserName(update.user)}
              </Typography>
            </Box>
            <Box className="status-container">
              <Typography variant="body2" color="textSecondary">
                {update.status.name}
              </Typography>
            </Box>
          </Box>
        </div>
      ))}
    </Card>
  );
}
